import React from 'react';
import { useSelector } from 'react-redux';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import { generateTitleAndSource } from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';

export const PopulationGrowth = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { populationGrowth } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.populationGrowth.populationGrowth,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.populationGrowth ? (
        <ErrorState />
      ) : (
        <>
          <table>
            <tr>
              <th>{nls.charts.populationGrowth.ageGroup}</th>
              <th>{nls.charts.populationGrowth.population2010}</th>
              <th>{nls.charts.populationGrowth.population2021}</th>
              <th>{nls.charts.populationGrowth.tgca}</th>
            </tr>
            {Object.keys(populationGrowth || []).map((popgrowth, index) => {
              return (
                <tr key={index}>
                  <td>{popgrowth}</td>
                  <td>{populationGrowth[popgrowth]?.population2010}</td>
                  <td>{populationGrowth[popgrowth]?.population2021}</td>
                  <td>{populationGrowth[popgrowth]?.TGCA}</td>
                </tr>
              );
            })}
          </table>
        </>
      )}
    </GenericChartCard>
  );
};
